import { Icon24Camera, Icon24Document, Icon24ScanViewfinderOutline } from '@vkontakte/icons';
import { Modals } from '../../../Consts';
import { Alert, ButtonGroup, ModalCard, SubnavigationButton, ToolButton } from '@vkontakte/vkui';
import React from 'react';
import { useAppContext } from '../../../AppContext';
import { APP_PLATFORM_TYPE_VK } from '../../../App';
import { getRouteCreatePaymentFromQrCode, getRouteCreatePaymentsFromQrCode } from '../../../route';
import { checkEventStatus, checkEventStatusForCreatePayment, getResponseFromError } from '../../../helpers/helpers';
import PropTypes from 'prop-types';

const CURRENT_COMPONENT = 'ScanReceiptButtonComponent';

const onSelectScanReceiptHandler = (file, eventId, context, routeTo) => {
  if (file === null || file === undefined) {
    return;
  }

  if (file.size >= context.store.maxFileSize) {
    return;
  }

  const checkStatusScanReceiptHandler = (eventId, receiptId) => {
    const interval = setInterval(() => {
      context.httpClient()
        .getReceiptInfo(eventId, receiptId)
        .then((response) => {
          const status = response.data?.status || 'error';
          if (status === 'error') {
            clearInterval(interval);
            context.spinner(false);
            context.showError(null, context.lang().getKey('errors', 'errorScanCashReceipt'));
          } else if (status === 'finish') {
            clearInterval(interval);
            context.spinner(false);

            const items = (response.data.items || []);
            const countItems = items.length;

            if (countItems < 1) {
              context.showError(null, context.lang().getKey('errors', 'errorScanCashReceipt'));
              return
            }

            const actions = [];
            let text = '';
            if (countItems < 2) {
              actions.push({
                title: context.lang().getKey(CURRENT_COMPONENT, 'qr_scan_action_add_title'),
                mode: 'cancel',
                action: () => routeTo(...getRouteCreatePaymentFromQrCode(eventId, (items[0].name || ''), (items || []), response.data.date, response.data.id)),
              });
              text = context.lang().getKey(CURRENT_COMPONENT, 'qr_scan_actions_text_one_position');
            } else {
              actions.push({
                title: context.lang().getKey(CURRENT_COMPONENT, 'qr_scan_action_by_positions_title'),
                mode: 'destructive',
                action: () => routeTo(...getRouteCreatePaymentsFromQrCode(eventId, response.data.items || [], response.data.date, response.data.id)),
              });
              actions.push({
                title: context.lang().getKey(CURRENT_COMPONENT, 'qr_scan_action_one_sum_title'),
                mode: 'cancel',
                action: () => routeTo(...getRouteCreatePaymentFromQrCode(eventId, '', response.data.items || [], response.data.date, response.data.id)),
              });
              text = context.lang().getKey(CURRENT_COMPONENT, 'qr_scan_actions_text', '', {
                countItems,
                position: context.lang().declOfNum(CURRENT_COMPONENT, 'qr_scan_actions_text_position', countItems),
              });
            }

            context.popout(<Alert
              actions={actions}
              onClose={() => context.popout(null)}
              text={text}
            />);
          }
        })
        .catch((error) => {
          console.error(error);
          context.spinner(false);
          clearInterval(interval);
        });
    }, 5 * 1000);
  }

  context.spinner(true);
  context.httpClient()
    .scanReceipt(eventId, file)
    .then((response) => {
      if (response.data.success && response.data.id) {
        checkStatusScanReceiptHandler(eventId, response.data.id);
      } else {
        context.showError(null, context.lang().getKey('app', 'error_modal_message'));
      }
      context.store.clearScanReceiptsCache(eventId);
    })
    .catch((error) => {
      context.store.clearScanReceiptsCache(eventId);
      const response = getResponseFromError(error);
      if (!response) {
        context.showError(error);
        return;
      }

      if (response.data) {
        context.showError(null, response.data, '');
      } else if (response.message) {
        context.showError(null, response.message, '');
      }
    });
}

export const ScanReceiptButtonComponent = ({label, event}) => {
  const context = useAppContext();
  const inputFile = React.useRef(null);

  const openModalHandler = () => {
    if (checkEventStatusForCreatePayment(context, event)) {
      context.router.showModal(Modals.SCAN_RECEIPT_MODAL);
    }
  }

  const selectFileHandler = () => {
    if (checkEventStatusForCreatePayment(context, event)) {
      return inputFile.current.click()
    }
  }

  const openPlatform = context.appOpenParams.vk_platform || context.appOpenParams.tgWebAppPlatform || '';

  if (context.platform === APP_PLATFORM_TYPE_VK && openPlatform.includes('android')) {
    return (<SubnavigationButton
      before={<Icon24ScanViewfinderOutline />}
      size="m"
      textLevel={'1'}
      selected={true}
      onClick={openModalHandler}
    >
      {label}
    </SubnavigationButton>);
  }

  return (<>
    <input
      type="file"
      accept="image/*"
      style={{display: 'none'}}
      ref={inputFile}
      onChange={(e) => onSelectScanReceiptHandler((e.target.files[0] || null), event.id, context, context.router.push)}
    />
    <SubnavigationButton
      before={<Icon24ScanViewfinderOutline />}
      size="m"
      textLevel={'1'}
      selected={true}
      onClick={selectFileHandler}
    >
      {label}
    </SubnavigationButton>
  </>);
}

ScanReceiptButtonComponent.propTypes = {
  label: PropTypes.string.isRequired,
  event: PropTypes.object.isRequired,
};

export const ScanReceiptModal = () => {
  const context = useAppContext();
  const params = context.router.getParams();

  const inputCamera = React.useRef(null)
  const inputFile = React.useRef(null)

  return (
    <ModalCard
      id={Modals.SCAN_RECEIPT_MODAL}
      onClose={() => context.back()}
    >
      {context.snackbar}
      <input
        type="file"
        accept="image/*"
        capture
        style={{display: 'none'}}
        ref={inputCamera}
        onChange={(event) => onSelectScanReceiptHandler((event.target.files[0] || null), params.eventId, context, context.router.replace)}
      />
      <input
        type="file"
        accept="image/*"
        style={{display: 'none'}}
        ref={inputFile}
        onChange={(event) => onSelectScanReceiptHandler((event.target.files[0] || null), params.eventId, context, context.router.replace)}
      />

      <ButtonGroup
        mode="horizontal"
        gap="m"
        stretched
      >
        <ToolButton
          IconCompact={Icon24Camera}
          IconRegular={Icon24Camera}
          direction="column"
          mode="primary"
          appearance="accent"
          onClick={() => inputCamera.current.click()}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'button_label__open_camera')}
        </ToolButton>
        <ToolButton
          IconCompact={Icon24Document}
          IconRegular={Icon24Document}
          direction="column"
          mode="primary"
          appearance="accent"
          onClick={() => inputFile.current.click()}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'button_label__open_gallery')}
        </ToolButton>
      </ButtonGroup>
    </ModalCard>
  );
}